// ── Mock data para Managed Streaming Status ──
// Representa una radio con streaming administrado por RFW (RFW_MANAGED).
// Datos usados como fallback cuando Supabase no está disponible.

import type { ManagedStreamingDetails } from '@/types/managedStreaming';

/** Mock: radio con streaming administrado RFW en estado ACTIVE */
export const adminManagedStreamingData: ManagedStreamingDetails = {
  streamingMode: 'RFW_MANAGED',
  provisioningStatus: 'ACTIVE',
  planId: 'pro',
  planName: 'Pro',
  planPrice: '$29.99/mes',
  planFeatures: [
    'Streaming administrado 24/7',
    'AutoDJ incluido',
    '500 GB almacenamiento',
    'Hasta 5,000 oyentes simultáneos',
    'Bitrate hasta 320 kbps',
    'SSL incluido',
    'Estadísticas en tiempo real',
    'Soporte prioritario',
    'App móvil personalizada',
  ],
  autodjIncluded: true,
  streamingHostingIncluded: true,
  storageGb: 500,
  bitrate: 192,
  listenersMax: 5000,
  streamUrl: 'https://stream.radiofrecuenciaweb.com/nueva-actitud',
  requestedAt: '2026-06-15T10:30:00',
  lastAttemptAt: '2026-06-15T10:35:00',
  lastError: null,
  canRetry: false,
  externalStreamValidated: null,
  externalStreamUrl: null,
};

/** Mock: radio con streaming propio (EXTERNAL_STREAM) */
export const externalStreamMockData: ManagedStreamingDetails = {
  streamingMode: 'EXTERNAL_STREAM',
  provisioningStatus: 'EXTERNAL_STREAM',
  planId: null,
  planName: null,
  planPrice: null,
  planFeatures: [],
  autodjIncluded: false,
  streamingHostingIncluded: false,
  storageGb: null,
  bitrate: null,
  listenersMax: null,
  streamUrl: null,
  requestedAt: null,
  lastAttemptAt: null,
  lastError: null,
  canRetry: false,
  externalStreamValidated: true,
  externalStreamUrl: 'https://stream.nuevaactitud.com/live',
};

/** Mock: radio RFW_MANAGED en estado FAILED (para testear UI de error) */
export const failedProvisioningMockData: ManagedStreamingDetails = {
  streamingMode: 'RFW_MANAGED',
  provisioningStatus: 'FAILED',
  planId: 'premium',
  planName: 'Premium',
  planPrice: '$59.99/mes',
  planFeatures: [
    'Streaming administrado 24/7',
    'AutoDJ incluido',
    '1 TB almacenamiento',
    'Hasta 25,000 oyentes simultáneos',
    'Bitrate hasta 320 kbps',
    'SSL incluido',
    'Estadísticas avanzadas',
    'Soporte 24/7',
    'App móvil personalizada',
    'API de acceso',
  ],
  autodjIncluded: true,
  streamingHostingIncluded: true,
  storageGb: 1000,
  bitrate: null,
  listenersMax: 25000,
  streamUrl: null,
  requestedAt: '2026-07-10T08:00:00',
  lastAttemptAt: '2026-07-10T08:05:00',
  lastError: 'El proveedor de streaming no respondió a tiempo. Esto puede deberse a mantenimiento programado. Intentá de nuevo en unos minutos.',
  canRetry: true,
  externalStreamValidated: null,
  externalStreamUrl: null,
};

/** Mock: radio RFW_MANAGED en estado PROVISIONING */
export const provisioningMockData: ManagedStreamingDetails = {
  streamingMode: 'RFW_MANAGED',
  provisioningStatus: 'PROVISIONING',
  planId: 'pro',
  planName: 'Pro',
  planPrice: '$29.99/mes',
  planFeatures: [
    'Streaming administrado 24/7',
    'AutoDJ incluido',
    '500 GB almacenamiento',
    'Hasta 5,000 oyentes simultáneos',
    'Bitrate hasta 320 kbps',
    'SSL incluido',
    'Estadísticas en tiempo real',
    'Soporte prioritario',
  ],
  autodjIncluded: true,
  streamingHostingIncluded: true,
  storageGb: 500,
  bitrate: null,
  listenersMax: 5000,
  streamUrl: null,
  requestedAt: '2026-07-15T14:00:00',
  lastAttemptAt: '2026-07-15T14:01:00',
  lastError: null,
  canRetry: false,
  externalStreamValidated: null,
  externalStreamUrl: null,
};